import VFacebookLogin from "vue-facebook-login-component";
import FbIcon from "@/assets/images/icons/fb.svg?inline";
import { SOCIAL_AUTH } from "../../gql/AuthQueries";

export default {
  name: "facebook_auth",

  data() {
    return {
      submitFbLoading: false,
      fbToken: "",
      facebook: {
        FB: {},
        model: {},
        appId: process.env.VUE_APP_FACEBOOK_APPID
      },
      agentLicense: "",
      firmName: ""
    };
  },

  mounted: function() {
    if (localStorage.getItem("signupAgentInfo")) {
      let signupAgentInfo = JSON.parse(localStorage.getItem("signupAgentInfo"));
      this.agentLicense = signupAgentInfo.licensse;
      this.firmName = signupAgentInfo.firmName;
    }
  },

  computed: {
    connected() {
      return this.facebook.model.connected;
    },
    disconnected() {
      return !this.connected;
    },

    computedButtonStyle() {
      let icon =
        "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDhWMTVDMCAxNS41NTIzIDAuNDQ3NzE1IDE2IDEgMTZIMTVDMTUuNTUyMyAxNiAxNiAxNS41NTIzIDE2IDE1VjhWMUMxNiAwLjQ0NzcxNSAxNS41NTIzIDAgMTUgMEg4SDFDMC40NDc3MTUgMCAwIDAuNDQ3NzE1IDAgMVY4WiIgZmlsbD0iIzM2NjVDMiIvPgo8cGF0aCBkPSJNMTEuMTE0MSAxMC4zMTI1TDExLjQ2ODggOEg5LjI1VjYuNUM5LjI1IDUuODY3MTkgOS41NTkzOCA1LjI1IDEwLjU1MzEgNS4yNUgxMS41NjI1VjMuMjgxMjVDMTEuNTYyNSAzLjI4MTI1IDEwLjY0NjkgMy4xMjUgOS43NzE4OCAzLjEyNUM3Ljk0Mzc1IDMuMTI1IDYuNzUgNC4yMzI4MSA2Ljc1IDYuMjM3NVY4SDQuNzE4NzVWMTAuMzEyNUg2Ljc1VjE2QzcuNSAxNiA3LjU3NSAxNiA4IDE2QzguNDI1IDE2IDggMTYgOS4yNSAxNlYxMC4zMTI1SDExLjExNDFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
      if (this.submitFbLoading) {
        icon =
          "data:image/svg+xml;base64,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";
      }

      return {
        cursor: "pointer",
        backgroundColor: "transparent",
        backgroundImage: `url(${icon})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: this.submitFbLoading ? "45px" : "",
        backgroundPosition: this.submitFbLoading ? "7px 0" : "24px 14px",
        color: "#919197",
        border: "1px solid #919197",
        padding: "0.75rem 1.5rem 0.75rem 3.375rem",
        minWidth: "100%",
        fontSize: "0.875rem",
        justifyContent: "flex-start"
      };
    },

    computedFBIcon() {
      return {
        display: "none"
      };
    },

    computedLoaderStyle() {
      return {
        height: "16px",
        width: "16px",
        borderColor: "#4f71e8",
        borderTopColor: "white"
      };
    }
  },

  methods: {
    handleSdkInit({ FB }) {
      this.facebook.FB = FB;

      this.fbToken = this.facebook.FB.getAccessToken();
    },

    fbLogin(event) {
      if (event.authResponse && event.authResponse.accessToken) {
        this.fbToken = this.facebook.FB.getAccessToken();

        this.loginRequest();
      }
    },

    loginRequest() {
      this.submitFbLoading = true;

      this.$apollo
        .mutate({
          mutation: SOCIAL_AUTH,
          variables: {
            provider: "facebook",
            accessToken: this.fbToken,
            role: localStorage.getItem("signupAgentInfo") ? "agent" : "buyer",
            brokerName: this.firmName,
            licence: this.agentLicense,
            filters: (this.$store.state.filters && this.$store.state.filters.length) ? this.$store.state.filters.filter(filter => filter.filters) : [],
            propertyTypeId: parseInt(this.$store.state.propertyTypeId)
          }
        })
        .then(({ data: { socialAuth: { user, accessToken } } }) => {
          this.$store.dispatch("initUser", user);

          if (typeof localStorage !== "undefined" && accessToken) {
            localStorage.setItem("AUTH_TOKEN", accessToken);
          }

          this.$toasted.success("You have been signed up!");

          if (user.role == "buyer") {
            if (user.firstName) {
              this.$router.push({
                name: "home"
              });
            } else {
              this.$router.push({
                name: "personalize"
              });
            }
          } else {
            if (user.needUploadAgentDocuments) {
              this.$router.push({
                name: "identity_documents"
              });
            } else {
              this.$router.push({
                name: "home"
              });
            }
          }
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.submitFbLoading = false;
        });
    }
  },

  components: {
    VFacebookLogin,
    FbIcon
  }
};
